import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { ListItemText, ListItem, Typography } from '@material-ui/core';
import { Icon } from 'front-onceforall-core';
import styles from './styles';
import CustomRow from './CustomRow';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CustomInputs(_ref) {
  let {
    customDocs,
    onAddCustom,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(ListItem, {
      alignItems: "flex-start",
      children: /*#__PURE__*/_jsx(ListItemText, {
        "data-id": "custom-category-label",
        primary: /*#__PURE__*/_jsx(Typography, {
          variant: "body2",
          children: /*#__PURE__*/_jsx(Translate, {
            value: "project.documents.otherDocuments"
          })
        }),
        disableTypography: true
      })
    }), /*#__PURE__*/_jsx("div", {
      "data-id": "custom-list",
      className: "mt-3 ml-3 mr-3",
      children: customDocs.map(doc => /*#__PURE__*/_jsx(CustomRow, {
        onChangeLabel: props.onChangeLabel,
        onRemoveCustom: props.onRemoveCustom,
        onCheckboxChange: props.onCheckboxChange,
        isOnEdit: props.isOnEdit,
        customDoc: doc
      }, doc.code ?? doc.id))
    }), /*#__PURE__*/_jsxs("div", {
      "data-id": "add-custom",
      style: styles.containerAddCustom,
      className: "clickable",
      onClick: onAddCustom,
      children: [/*#__PURE__*/_jsx("div", {
        style: styles.line
      }), /*#__PURE__*/_jsxs("p", {
        className: "flex-container",
        style: styles.text,
        children: [/*#__PURE__*/_jsx(Translate, {
          value: "project.documents.customPlaceholderAdd"
        }), /*#__PURE__*/_jsx(Icon, {
          icon: "rounded-plus"
        })]
      })]
    })]
  });
}
CustomInputs.defaultProps = {
  isOnEdit: false
};
CustomInputs.propTypes = {
  onChangeLabel: PropTypes.func.isRequired,
  onRemoveCustom: PropTypes.func.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  onAddCustom: PropTypes.func.isRequired,
  isOnEdit: PropTypes.bool,
  customDocs: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    requiredInProject: PropTypes.bool.isRequired
  }))
};
export default CustomInputs;